import {
  CategoryScale,
  Chart as ChartJS,
  Filler,
  Legend,
  LineElement,
  LinearScale,
  PointElement,
  Title,
  Tooltip,
} from "chart.js";
import React, { useEffect, useState } from "react";
import { convertToMoney, numberFormat } from "../utils/number";
import { defaultData, labels, options } from "./config/charts/DashboardOptions";
import { formatDate, formatMonthYear } from "../utils/moment";
import {
  getBalanceCCI,
  getEvolutivo,
  getResumenCuenta,
  getRentabilidadPorMeses,
  getUltimoAporte,
} from "../services/dashboard";

import Constants from "./../utils/constants";
import { Line } from "react-chartjs-2";
import { Link } from "react-router-dom";
import WithMainLayout from "../hocs/layouts/MainLayout";
import { useAPIs } from "../apis/APIsConfig";
import { useDocTitle } from "../utils/hooks";
import { useGlobalStore } from "../utils/global";
import { getObtenerValorPorCodigo } from "../services/parameters";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
);

function Dashboard() {
  useDocTitle("Mi Cuenta");
  useAPIs();

  const { user } = useGlobalStore();

  const [resumen, setResumen] = useState<any>({});
  const [resumenMeses, setRentabilidadMeses] = useState<any>({});
  const [resumenParametro, setParametros] = useState<any>({});
  const [ultimoAporte, setUltimoAporte] = useState<any>({});
  const [chartData, setChartData] = useState<any>({
    labels,
    datasets: [],
  });

  useEffect(() => {
    getResumenCuenta().then((resumen) => {
      debugger;
      if (resumen) {
        setResumen(resumen.data.value);

        getObtenerValorPorCodigo(Constants.MESES_ESTCUENTA_OFV).then((resumenParametro) => {
          if (resumenParametro && resumenParametro.data.successed && resumenParametro.data.value.estado == true) {
            setParametros(resumenParametro.data.value);

            /* getRentabilidadPorMeses(resumenParametro.data.value.valor).then((resumenMeses) => {
              if (resumenMeses) {
                setRentabilidadMeses(resumenMeses.data.value);
              }
            }); */
          }
        });

        getUltimoAporte().then((ultimoAporte) => {
          setUltimoAporte(ultimoAporte.data.value);
        });

        getEvolutivo().then((evolutivo) => {
          const data = { ...defaultData };
          const graphData = evolutivo.data.value.reverse();
          data.labels = graphData.map((m) => {
            return formatMonthYear(m.fechaCorte);
          });
          data.datasets[0].data = graphData.map((m) => m.monSaldoFin);
          setChartData(data);
        });
      }
    });
  }, []);

  return (
    <>
      <div className="block pt-14 pb-[100px] lg:pb-[140px] xl:pb-[180px]">
        <div className="block lg:flex justify-between items-center pb-4 md:pb-6">
          <div className="block pb-4 lg:pb-0">
            <p className="text-gray-70 text-body-1 font-body font-normal mb-2">
              Balance acumulado al corte ({resumen != undefined ? formatDate(resumen.fechaCorte, "L") : ""} )
            </p>
            <h2 className="text-primary-100 font-bold">
              RD$ {resumen != undefined ? convertToMoney(resumen.monto) : 0}
            </h2>
          </div>
          <Link
            to={Constants.APPURLS.ACCOUNT_STATEMENTS}
            className="btn btn-primary btn-medium hidden lg:inline-flex"
          >
            Estados de Cuenta
          </Link>
        </div>
        <div className="block w-full bg-neutral-white border border-gray-10 rounded-lg px-3 md:px-8 pt-3 md:pt-8 pb-3 md:pb-[22px] shadow-base mb-6 md:mb-8">
          <Line options={options} data={chartData} width={200} height={295} />
        </div>
        <Link
          to={Constants.APPURLS.ACCOUNT_STATEMENTS}
          className="btn btn-primary btn-small w-full flex lg:hidden mb-8 lg:mb-0"
        >
          Estados de Cuenta
        </Link>
        <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4 gap-4 shadow-box rounded-lg border border-gray-10 bg-neutral-white p-6">
          <div className="info-card">
            <p>Último Aporte ({ultimoAporte ? formatDate(ultimoAporte.fecha, "MMMM YYYY") : ""})</p>
            <h5>RD$ {ultimoAporte ? convertToMoney(ultimoAporte.valor) : 0}</h5>
          </div>
          <div className="info-card">
            <p>Rendimiento Acumulado</p>
            <h5>RD$ {resumen ? convertToMoney(resumen.montoRendimiento) : 0}</h5>
          </div>
          <div className="info-card">
            <p>Rentabilidad de los últimos {resumenParametro ? numberFormat(resumenParametro.valor) : 0} meses</p>
            <h5>{resumen ? convertToMoney(resumen.rentabilidad) : 0}%</h5>
          </div>
          <div className="info-card">
            <p>Cantidad de Cotizaciones</p>
            <h5>{resumen ? numberFormat(resumen.cantidadCotizacion) : 0}</h5>
          </div>
        </div>
      </div>
    </>
  );
}

export default WithMainLayout(Dashboard, "Mi Cuenta");
